import { api } from "./api";
import { tokenReceived, userReceived, loggedOut } from "@/store/auth";
import authConfig from "@/config/auth.ts";
import type { LoginResponse, User } from "@/types/api/types.ts";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials: { email: string; password: string }) => ({
        url: authConfig.loginEndpoint,
        method: "POST",
        body: credentials,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data }: { data: LoginResponse } = await queryFulfilled;
          dispatch(
            tokenReceived({
              accessToken: data.token,
            })
          );
          dispatch(userReceived(data.user));
        } catch (error) {
          // Handle error
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } finally {
          dispatch(loggedOut());
        }
      },
    }),
    getMe: builder.query({
      query: () => "/me",
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(userReceived(data));
        } catch {
          dispatch(loggedOut());
        }
      },
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation, useGetMeQuery } = authApi;
